import { doctorsActions } from "../slices/doctorsSlice";
import { commentActions } from "../slices/commentSlice";
import { toast } from "react-toastify";
import axios from "axios";

//Create comment
export function createComment(newComment) {
  return async (dispatch, getstate) => {
    try {
      const { data } = await axios.post(`https://tabeeb-assyut-api.onrender.com/api/comments`, newComment, {
        headers: {
          Authorization: "Bearer " + getstate().auth.user.token,
        },
      });
      dispatch(doctorsActions.addCommentToDoctor(data));
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
}
//Update comment
export function updateComment(commentId, newComment) {
  return async (dispatch, getstate) => {
    try {
      const { data } = await axios.put(
        `https://tabeeb-assyut-api.onrender.com/api/comments/${commentId}`,
        newComment,
        {
          headers: {
            Authorization: "Bearer " + getstate().auth.user.token,
          },
        }
      );
      dispatch(doctorsActions.updateCommentToDoctor(data));
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
}
//Delete comment
export function deleteComment(commentId) {
  return async (dispatch, getstate) => {
    try {
      await axios.delete(`https://tabeeb-assyut-api.onrender.com/api/comments/${commentId}`, {
        headers: {
          Authorization: "Bearer " + getstate().auth.user.token,
        },
      });
      dispatch(commentActions.deleteComment(commentId));
      dispatch(doctorsActions.deleteCommentFromDoctor(commentId));
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
}
//Fetch all comments
export function fetchAllComments() {
  return async (dispatch, getstate) => {
    try {
      const { data } = await axios.get(`https://tabeeb-assyut-api.onrender.com/api/comments`, {
        headers: {
          Authorization: "Bearer " + getstate().auth.user.token,
        },
      });
      dispatch(commentActions.setComments(data));
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
}
